<div class="manager-container">

  <hr class="manager-header" />

  <h1>License Information</h1>

  <form>
    <div class="mb-3 row">
      <span class="col-lg-2">License Status:</span>
      <span class="col-lg-4">{{licenseStatusMessage}}</span>
    </div>
    <div class="mb-3 row">
      <span class="col-lg-2">Licensed To:</span>
      <span class="col-lg-4">{{licensedTo}}</span>
    </div>
    <div class="mb-3 row">
      <span class="col-lg-2">Product Key:</span>
      <span class="col-lg-4">{{encodedProductKey}}</span>
    </div>
    <div class="mb-3 row">
      <span class="col-lg-2">License Limit:</span>
      <span class="col-lg-4">{{licenseLimitStr}}</span>
    </div>
    <div class="mb-3 row">
      <span class="col-lg-2">License Used:</span>
      <span class="col-lg-4">{{licenseCountStr}}</span>
    </div>
  </form>

  <form style="margin-top: 20px;">
    <div>
      <span>
        <button type="button" pButton class="manager-button" (click)="activateLicense()" [disabled]="hasLocalLicense"
        label="Activate License..."></button>
      </span>

      <span>
        <button type="button" pButton class="manager-button" (click)="updateLicense()" [disabled]="hasLocalLicense"
        label="Update License..."></button>
      </span>

      <span>
        <button type="button" pButton class="manager-button" (click)="deactivateLicense()" [disabled]="hasLocalLicense"
        label="Deactivate License..."></button>
      </span>

    </div>
  </form>

  <hr class="manager-header" />

  <h1>Product Information</h1>

  <form>
    <div class="mb-3 row">
      <span class="col-lg-2">Product Version:</span>
      <span class="col-lg-4">{{productVersion}}</span>
    </div>
    <div class="mb-3 row">
      <span class="col-lg-2">Software Version:</span>
      <span class="col-lg-4">{{softwareVersion}}</span>
    </div>
  </form>

  <hr class="manager-header" />

  <h1>Software Update</h1>

  <div style="display: inline-block; padding: 10px 20px 10px 20px; border-radius: 15px; margin-top: 10px;"
    [ngClass]="{'update-available': swUpdateIsNew}">

    <div class="update-message">{{swUpdateMessage}}</div>

    @if (swUpdateIsNew) {
      <div>
        <div class="update-message">
          <a href="{{swUpdateSetupUrl}}">Click here to run the installer for the new version.</a>
        </div>
        <div class="update-message">
          <a href="{{swUpdateInstallerUrl}}">Or, click here to download a zip file containing the installer for the new version.</a>
          After downloading, unzip the file and run UvxServerInstaller.exe
        </div>
        <div style="margin-bottom: 10px;" class="update-message">
          <div>Either way, be sure to run the installer on the machine that is running UVexplorer Server.</div>
        </div>
      </div>
    }
  </div>

  <div style="margin-top: 20px;">
    <button type="button" pButton class="manager-button" (click)="checkForSoftwareUpdate()" [disabled]="!enableCheckForSwUpdate"
    label="Check For Software Update"></button>
  </div>

  <activation-wizard [(visible)]="activationWizardVisible" (onOk)="onLicenseChange()"
  (onCancel)="onLicenseChange()"></activation-wizard>

  <deactivation-wizard [(visible)]="deactivationWizardVisible" (onOk)="onLicenseChange()"
  (onCancel)="onLicenseChange()"></deactivation-wizard>

  <update-license-wizard [(visible)]="updateWizardVisible" (onOk)="onLicenseChange()"
  (onCancel)="onLicenseChange()"></update-license-wizard>
</div>